import { useState } from "react";
import { PageHeader } from "@/components/layout/Layout";
import { Select, TabPanel, Tabs } from "@/components/ui";
import { OverviewTab } from "./OverviewTab";
import { ReceiptsTab } from "./ReceiptsTab";
import { UvaTab } from "./UvaTab";
import { ExportTab } from "./ExportTab";

const TABS = [
  { value: "overview", label: "Übersicht" },
  { value: "receipts", label: "Belege" },
  { value: "uva", label: "UVA" },
  { value: "export", label: "Export" },
];

export function Tax() {
  const now = new Date().getFullYear();
  const [tab, setTab] = useState("overview");
  const [year, setYear] = useState(now);

  return (
    <div className="flex flex-col h-full">
      <PageHeader
        title="Steuer & Export"
        actions={
          <Select
            value={String(year)}
            onChange={(e) => setYear(Number(e.target.value))}
            options={[now, now - 1, now - 2].map((y) => ({
              value: String(y),
              label: String(y),
            }))}
          />
        }
      />
      <Tabs value={tab} onValueChange={setTab} tabs={TABS}>
        <div className="flex-1 overflow-y-auto">
          <TabPanel value="overview">
            <OverviewTab year={year} />
          </TabPanel>
          <TabPanel value="receipts">
            <ReceiptsTab year={year} />
          </TabPanel>
          <TabPanel value="uva">
            <UvaTab year={year} />
          </TabPanel>
          <TabPanel value="export">
            <ExportTab year={year} />
          </TabPanel>
        </div>
      </Tabs>
    </div>
  );
}
